import { USE_MOCK_API } from 'shared/services/api/config';
import { apiGet } from 'shared/services/api/resource';
import { FEATURED_ARENAS, FeaturedArena, SPORT_OPTIONS } from 'modules/jogador/home/content';
import { ArenaProfile, lowestCourtPrice } from 'shared/contexts/ArenaProfileContext';

export interface ArenaSearchParams {
  searchTerm: string;
  sportId: string;
}

// Converte a arena cadastrada no onboarding para o card do marketplace.
export function toFeaturedArena(profile: ArenaProfile): FeaturedArena {
  const sportIds = profile.sports
    .map((label) => SPORT_OPTIONS.find((option) => option.label === label)?.id)
    .filter((id): id is string => Boolean(id));

  return {
    id: 'demo-own-arena',
    status: 'Aberto agora',
    rating: 0,
    reviewCount: 0,
    name: profile.arenaName,
    neighborhood: profile.unitName.replace(/^Unidade\s+/i, ''),
    address: [profile.address, profile.city].filter(Boolean).join(' - ') || profile.city,
    sportIds,
    tags: profile.sports.slice(0, 3),
    priceFrom: lowestCourtPrice(profile),
    isNew: true,
  };
}

function filterMockArenas({ searchTerm, sportId }: ArenaSearchParams, ownArena: FeaturedArena | null): FeaturedArena[] {
  const term = searchTerm.trim().toLowerCase();
  return [...(ownArena ? [ownArena] : []), ...FEATURED_ARENAS].filter((arena) => {
    const matchesSport = sportId === 'todos' || arena.sportIds.includes(sportId);
    const matchesTerm =
      term.length === 0 ||
      arena.name.toLowerCase().includes(term) ||
      arena.neighborhood.toLowerCase().includes(term);
    return matchesSport && matchesTerm;
  });
}

export function searchArenas(params: ArenaSearchParams, ownArena: FeaturedArena | null = null): Promise<FeaturedArena[]> {
  const query = new URLSearchParams({ q: params.searchTerm, sport: params.sportId }).toString();
  return apiGet(USE_MOCK_API ? filterMockArenas(params, ownArena) : [], `/arenas/search?${query}`, 250);
}
